/**
 * FamilyPage — standalone page at /family.
 *
 * Wraps FamilyMembers in the standard cvr-account chrome (top bar + wrap).
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import FamilyMembers from './FamilyMembers';
import logoUrl from '../../assets/images/cleveroo-logo.png';
import '../../components/AccountPages.css';

const FamilyPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="cvr-account">
      {/* Top bar */}
      <div className="cvr-account__bar">
        <button
          type="button"
          className="cvr-account__back"
          onClick={() => navigate('/')}
        >
          ← Dashboard
        </button>
        <span className="cvr-account__brand">
          <img src={logoUrl} alt="" />
          Cleveroo
        </span>
      </div>

      <div className="cvr-account__wrap">
        <h1 className="cvr-account__title">Family</h1>
        <p style={{ color: '#6B7A6F', fontSize: 15, marginTop: -8 }}>
          Link your children's accounts so they share your subscription.
        </p>

        <FamilyMembers />
      </div>
    </div>
  );
};

export default FamilyPage;
